export default __webpack_public_path__ + "static/media/solean-energy-bg.a872bf63.jpeg";